import { showSmartMessage, smartConfirm } from '../../../../../packages/app-foundation/src/feedback'
// Portal feedback shell delegates to app-foundation MessagePlugin / DialogPlugin wrappers.

type PortalMessageTheme = 'success' | 'info' | 'warning' | 'error'
type PortalMessageInput = string | Record<string, unknown>
type PortalMessageOptions = Record<string, unknown>
type PortalConfirmOptions = Record<string, unknown>
type PortalConfirmInstance = {
  onConfirm: (handler: () => unknown | Promise<unknown>) => unknown
  onClose?: (handler: () => unknown | Promise<unknown>) => unknown
  onCancel?: (handler: () => unknown | Promise<unknown>) => unknown
  destroy: () => unknown
}

function normalizeMessage(input: PortalMessageInput, options: PortalMessageOptions = {}) {
  if (typeof input === 'string') {
    return {
      content: input,
      ...options,
    }
  }

  return {
    ...input,
    ...options,
  }
}

export function showPortalMessage(
  theme: PortalMessageTheme,
  input: PortalMessageInput,
  options: PortalMessageOptions = {},
) {
  return showSmartMessage(theme, normalizeMessage(input, options))
}

export const portalMessage = {
  success(input: PortalMessageInput, options?: PortalMessageOptions) {
    return showPortalMessage('success', input, options)
  },
  info(input: PortalMessageInput, options?: PortalMessageOptions) {
    return showPortalMessage('info', input, options)
  },
  warning(input: PortalMessageInput, options?: PortalMessageOptions) {
    return showPortalMessage('warning', input, options)
  },
  error(input: PortalMessageInput, options?: PortalMessageOptions) {
    return showPortalMessage('error', input, options)
  },
}

export function portalConfirm(options: PortalConfirmOptions) {
  return smartConfirm(options) as PortalConfirmInstance
}

export function portalConfirmAsync(
  content: string,
  header = '提示',
  options: PortalConfirmOptions = {},
) {
  return new Promise<void>((resolve, reject) => {
    const dialog = portalConfirm({
      header,
      body: content,
      ...options,
    })

    dialog.onConfirm(() => {
      dialog.destroy()
      resolve()
    })

    const cancel = () => {
      dialog.destroy()
      reject(new Error('cancelled'))
    }

    dialog.onCancel?.(cancel)
    dialog.onClose?.(cancel)
  })
}
